<h2>Einstellungen</h2>
<p><strong>Hinweis: </strong> Fehlende Daten führen dazu, dass darauf basierende Prüfungen nicht durchgeführt werden!</p>
<div class="grid">
  @if (generalConfig) {
    <div class="col-4"><label for="date">Begin-Datum der Infoveranstaltung:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-datePicker inputId="date" dateFormat="dd.mm.yy" [(ngModel)]="generalConfig.targetDate"></p-datePicker>
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="date">End-Datum der Infoveranstaltung:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-datePicker inputId="date" dateFormat="dd.mm.yy" [(ngModel)]="generalConfig.targetDateEnd"></p-datePicker>
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="from">Anmeldungszeitraum von:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-datePicker inputId="from" dateFormat="dd.mm.yy" [(ngModel)]="generalConfig.registerStart"></p-datePicker>
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="to">Anmeldungszeitraum bis:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-datePicker inputId="to" dateFormat="dd.mm.yy" [(ngModel)]="generalConfig.registerEnd"></p-datePicker>
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="maxTotalAttendeesCount">Maximale Anzahl Teilnehmer:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input pInputText id="maxTotalAttendeesCount" type="number" [(ngModel)]="generalConfig.maxTotalAttendeesCount" min="0" style="width: 12ex">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="minCountInfo">Minimale Zahl {{'WORKSHOP'|translate}}:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input pInputText id="minCountInfo" type="number" [(ngModel)]="generalConfig.minCountWorkshop" min="0" style="width: 12ex">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="maxCountWorkshop">Maximale Zahl {{'WORKSHOP'|translate}}:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input pInputText id="maxCountWorkshop" type="number" [(ngModel)]="generalConfig.maxCountWorkshop" min="0" style="width: 12ex">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="minCountInfo">Minimale Zahl {{'INFO'|translate}}:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input pInputText id="" type="number" [(ngModel)]="generalConfig.minCountInfo" min="0" style="width: 12ex">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="maxCountInfo">Maximale Zahl {{'INFO'|translate}}:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input id="maxCountInfo" pInputText type="number" [(ngModel)]="generalConfig.maxCountInfo" min="0" style="width: 12ex">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="privacyPolicyText">Informationstext Datenschutzvereinbarung:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input id="privacyPolicyText" pInputText type="text" [(ngModel)]="generalConfig.privacyPolicyText" style="width: 100%">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="privacyPolicyUrl">Link zur Datenschutzvereinbarung:</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <input id="privacyPolicyUrl" pInputText type="text" [(ngModel)]="generalConfig.privacyPolicyUrl" style="width: 100%">
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="splitApplicationForm">Anmeldung auf zwei Seiten teilen<br>(Persönliche Daten und Veranstaltungsauswahl)</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-checkbox inputId="splitApplicationForm" [binary]="true" [(ngModel)]="generalConfig.splitApplicationForm"></p-checkbox>
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="showTypeInTable">Veranstaltungstyp in Tabelle anzeigen</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-checkbox inputId="showTypeInTable" [binary]="true" [(ngModel)]="generalConfig.showTypeInTable"></p-checkbox>
    </div>
  }
  @if (generalConfig) {
    <div class="col-4"><label for="showSalutationField">Feld "Anrede" anzeigen</label></div>
  }
  @if (generalConfig) {
    <div class="col-8">
      <p-checkbox inputId="showSalutationField" [binary]="true" [(ngModel)]="generalConfig.showSalutationField"></p-checkbox>
    </div>
  }
  <div class="col-4"><label>Titel Textfeld:</label></div>
  <div class="col-8">
    @if (generalConfig) {
      <edu-udo-itmc-dev-mini-book-simple-editor [(message)]="generalConfig.titleMessage"></edu-udo-itmc-dev-mini-book-simple-editor>
    }
  </div>
  <div class="col-4"><label>Veranstaltungs Textfeld:</label></div>
  <div class="col-8">
    @if (generalConfig) {
      <edu-udo-itmc-dev-mini-book-simple-editor [(message)]="generalConfig.bookingMessage"></edu-udo-itmc-dev-mini-book-simple-editor>
    }
  </div>
  <div class="col-4"><label>Anmeldung erfolgreich Textfeld:</label></div>
  <div class="col-8">
    @if (generalConfig) {
      <edu-udo-itmc-dev-mini-book-simple-editor [(message)]="generalConfig.applicationSuccessfulMessage"></edu-udo-itmc-dev-mini-book-simple-editor>
    }
  </div>
  <div class="col-4"><label>Vor dem Anmeldungszeitraum Information:</label></div>
  <div class="col-8">
    @if (generalConfig) {
      <edu-udo-itmc-dev-mini-book-simple-editor [(message)]="generalConfig.beforeRegisterStartMessage"></edu-udo-itmc-dev-mini-book-simple-editor>
    }
  </div>
  <div class="col-4"><label>Nach dem Anmeldungszeitraum Information:</label></div>
  <div class="col-8">
    @if (generalConfig) {
      <edu-udo-itmc-dev-mini-book-simple-editor [(message)]="generalConfig.afterRegisterEndMessage"></edu-udo-itmc-dev-mini-book-simple-editor>
    }
  </div>
  <div class="col-4"><label>Ausgebucht Information:</label></div>
  <div class="col-8">
    @if (generalConfig) {
      <edu-udo-itmc-dev-mini-book-simple-editor [(message)]="generalConfig.bookedUpMessage"></edu-udo-itmc-dev-mini-book-simple-editor>
    }
  </div>
  @if (generalConfigErrors) {
    <div class="col-12">
      <edu-udo-itmc-dev-mini-book-error-renderer [errors]="generalConfigErrors">
      </edu-udo-itmc-dev-mini-book-error-renderer>
    </div>
  }
  @if (generalConfig) {
    <div class="col-12 flex gap-2 justify-content-end align-items-center p-3">
      <p-button (click)="refreshGeneralConfig()" label="Zurücksetzen" ariaLabel="Zurücksetzen"></p-button>
      <p-button (click)="saveGeneralConfig()" label="Speichern" ariaLabel="Speichern"></p-button>
    </div>
  }
</div>
